import { z } from 'zod';
import { baseClaimSchema } from './baseClaim';
import { siteSchema } from './site';

export const submissionSchema = z.object({
  id: z.string(),
  filename: z.string(),
  uploaded: z.boolean(),
  cognitoID: z.guid().optional().nullable(),
  status: z.string(),
  createdAt: z.coerce.date(),
  siteID: z.string(),
  payorID: z.string(),
  startingClaim: z.string().nullable(),
  s3Path: z.string().nullable(),
  totalAmount: z.string().nullable(),
  submittedAt: z.coerce.date().nullable(),
  p1File: z.string().nullable(),
  site: z.lazy(() => siteSchema),
  claims: z.lazy(() => baseClaimSchema.array()),
});

export const submissionSummarySchema = submissionSchema
  .pick({
    id: true,
    filename: true,
    uploaded: true,
    cognitoID: true,
    status: true,
    createdAt: true,
    siteID: true,
    payorID: true,
    startingClaim: true,
    s3Path: true,
    totalAmount: true,
    submittedAt: true,
    p1File: true,
  })
  .extend({
    claimCount: z.number(),
  })
  .strict();

export type SubmissionSummary = z.infer<typeof submissionSummarySchema>;
